module.exports = __webpack_public_path__ + "img/server-error.36630528.svg";